import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Lock, Download, Shield } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="final-cta" className="py-24 px-6 bg-dark text-white text-center" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gold mb-12" data-id="element-17">
            Tienes dos caminos desde este momento.
          </h2>
        </FadeIn>

        <div className="space-y-8 text-lg text-gray-300 mb-12 text-left" data-id="element-18">
          <FadeIn delay={0.2} data-id="element-19">
            <div className="flex gap-4" data-id="element-20">
              <div className="text-gold/50 font-serif text-2xl font-bold" data-id="element-21">
                1.
              </div>
              <p data-id="element-22">
                <span className="text-white font-bold" data-id="element-23">El primero:</span> Cerrar
                esta página, seguir pagando renta, seguir con intereses altos y
                esperar a que "algo cambie" por sí solo.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-24">
            <div className="flex gap-4" data-id="element-25">
              <div className="text-gold font-serif text-2xl font-bold" data-id="element-26">2.</div>
              <p data-id="element-27">
                <span className="text-gold font-bold" data-id="element-28">El segundo:</span>{' '}
                Invertir hoy $16 dólares, descargar este manual en los próximos
                30 segundos y empezar mañana mismo a enviar las cartas que
                pueden cambiar el número que controla tu vida en este país.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} data-id="element-29">
          <p className="text-2xl md:text-3xl font-serif text-white mb-4 italic" data-id="element-30">
            Tu familia merece la casa. Tú mereces el "SÍ" del banco.
          </p>
          <p className="text-xl text-gold mb-12" data-id="element-31">
            La decisión cuesta $16. La indecisión cuesta años.
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-32">
          <Button className="w-full md:w-auto text-lg py-5 px-10 mb-8" onClick={() => {
          trackAddToCart();
          window.open('https://guiasparavivir.com/cart/52621004734753:1', '_blank');
        }} data-id="element-33">
            [ DESCARGAR MI PASAPORTE FINANCIERO — $16 AHORA ]
          </Button>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-400" data-id="element-34">
            <div className="flex items-center gap-2" data-id="element-35">
              <Lock size={16} data-id="element-36" /> Pago 100% seguro
            </div>
            <div className="hidden md:block" data-id="element-37">•</div>
            <div className="flex items-center gap-2" data-id="element-38">
              <Download size={16} data-id="element-39" /> Descarga inmediata
            </div>
            <div className="hidden md:block" data-id="element-40">•</div>
            <div className="flex items-center gap-2" data-id="element-41">
              <Shield size={16} data-id="element-42" /> Garantía de 30 días
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}